import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { _ } from "i18n";
import {DiscoverPlayersRowResponse} from "libs/apiClient";
import client from "libs/client";
import { useEffect, useState } from "react";
import DatagridV2, { type SimpleColumn } from "ui-kit/src/Datagrid/DatagridV2";
import { formatDate } from "features/discover/functions";

export function DiscoverUserGuardianApprovalsTable({
	columnVisibility,
	defaultFilters = {},
}: {
	columnVisibility?: Record<string, boolean>;
	defaultFilters?: { [key: string]: string | number | undefined };
}) {
    const [pagination, setPagination] = useState<{ pageIndex: number; pageSize: number }>({
        pageIndex: 0,
        pageSize: 15,
    });
    const [filters, setFilters] = useState<{ [key: string]: string | number | undefined }>({ ...defaultFilters});
    const [sort, setSort] = useState<{ field: string, direction: string }>();

    useEffect(() => { setScrollBehavior() }, []);

    const { data, isLoading } = client.getDiscoverUserGuardianApprovals.useQuery({
        page: pagination.pageIndex + 1,
		limit: pagination.pageSize,
		filters: [
            ...(filters?.user ? [{
                field: "user",
                type: "exact",
                value: filters.user,
            }] : []),
        ],
        order: sort
    })

    const simpleColumns: SimpleColumn<DiscoverPlayersRowResponse>[] = [
		{
			id: "createdAt",
			key: "createdAt",
			header: "Created at",
			cell: (value, row) => formatDate(row.createdAt),
		},
		{
			id: "user",
			key: "user",
			header: "User name",
			cell: (value, row) => row.user.name,
		},
		{
			id: "guardianFullName",
			key: "guardianFullName",
			header: "Name",
			cell: (value, row) => row.guardianFullName || '-',
		},
		{
			id: "guardianEmail",
			key: "guardianEmail",
			header: "E-mail",
			cell: (value, row) => row.guardianEmail || '-',
		},
		{
			id: "guardianFilledFullName",
			key: "guardianFilledFullName",
			header: "Filled name",
			cell: (value, row) => row.guardianFilledFullName || '-',
		},
		{
			id: "guardianFilledRole",
			key: "guardianFilledRole",
			header: "Filled role",
			cell: (value, row) => row.guardianFilledRole || '-',
		},
		{
			id: "status",
			key: "status",
			header: "Status",
			cell: (value, row) => <span style={{color: row.status === "APPROVED" ? "green" : "red"}}>{row.status}</span>,
		},
		{
			id: "approvedAt",
			key: "approvedAt",
			header: "Approved at",
			cell: (value, row) => formatDate(row.approvedAt),
		},
	];

	return (
		<DatagridV2
			isLoading={isLoading}
			simpleColumns={simpleColumns}
			data={data?.data.items ?? []}
			pageCount={data?.data?.pages ?? 1}
			pagination={pagination}
			setPagination={setPagination}
			noResults={_("datatables.zero_records")}
			columnVisibility={columnVisibility}
		/>
	)
}
